import { useId } from '@react-aria/utils';

export const useLinearGradientDetails = (): { id: string; url: string } => {
  const id = useId();

  return { id, url: `url(#${id})` };
};
